import clsx from 'clsx';
import React from 'react';

interface TagProps {
  className?: string;
  name: string;
}

const Tag = ({ name, className }: TagProps) => {
  return (
    <span
      className={clsx(
        'bg-primary-red rounded-28 px-12 py-2 ml-auto text-white \
        text-body-sm font-sans whitespace-nowrap hidden sm:text-xs xs:block',
        className
      )}
    >
      {name}
    </span>
  );
};

export default Tag;
